import React from "react";
import Link from "next/link";

import {baseRouteNewSummary} from "@/config/navigation.ts";
import {buttonVariants} from "@/app/components/ui/buttons/button.tsx";
import {cn} from "@videohighlight/ui/cn";

export const LoginButton = ({className}: { className?: string }) => {
    return (
        <Link href={baseRouteNewSummary}
              prefetch={false}
              className={cn(buttonVariants({variant: "secondary", size: "sm"}), "rounded-[8px] text-nowrap", className)}
        >Log In</Link>
    )
};